import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map, of } from 'rxjs';
import { FilesService } from '../shared/files.service';

@Injectable({
  providedIn: 'root'
})

export class ReportService {

  private REPORT_URL = environment.reportUrl + "rpt/"
  private PORTAL_URL = environment.apiUrl + "portal/"

  constructor(
    private http: HttpClient,
    private filesService: FilesService,
  ) { }

  /**
   * Llama al servicio para generar reportes
   * @param reportName Nombre del reporte
   * @param params objeto json con los parametros de envío al servicio
   * @returns archivo binario para ser renderizado
   */
  public call(reportName: string, params: any): Observable<any> {
    const queryParams = Object.keys(params).map((key) => {
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
    }).join('&');
    return this.http.get<any>(this.REPORT_URL + reportName + "?" +queryParams);
  }

  public getUrl(reportName: string, params: any): String {
    const queryParams = Object.keys(params).map((key) => {
      return encodeURIComponent(key) + '=' + encodeURIComponent(params[key])
  }).join('&');
  return this.REPORT_URL + reportName + "?" +queryParams;
  }

  public getBlob(url: string): Observable<Blob> {
    return this.http.get(url, { responseType: 'blob' })
  }

  public openReport(url: string, fallbackFilename: string = 'reporte.pdf'): void {
    if (!environment.production) {
      window.open(url, '_blank');
      return;
    }

    let newWin: Window | null = null;
    try {
      newWin = window.open('about:blank');
    } catch (e) {
      newWin = null;
    }

    if (newWin) {
      this.http.get(url, { responseType: 'blob', observe: 'response' }).subscribe({
        next: (response: HttpResponse<Blob>) => {
          const blob = response.body as Blob;
          const disposition = response.headers.get('Content-Disposition');
          const headerFilename = this.parseFilenameFromContentDisposition(disposition);
          const fileName = this.sanitizeFilename(headerFilename || fallbackFilename);
          const objectUrl = URL.createObjectURL(new File([blob], fileName, {
            type: blob.type || 'application/pdf'
          }));

          try {
            newWin!.location.href = objectUrl;
          } catch (e) {
            newWin!.location.replace(objectUrl);
          }

          setTimeout(() => {
            try { URL.revokeObjectURL(objectUrl); } catch (e) {}
          }, 1800000);
        },
        error: () => {
          try { newWin!.close(); } catch (e) {}
        }
      });
      return;
    }

    this.http.get(url, { responseType: 'blob' }).subscribe({
      next: (blob: Blob) => this.filesService.openFileFromOctectStream({ blob, filename: fallbackFilename }, false),
      error: () => window.open(url, '_blank')
    });
  }

  private parseFilenameFromContentDisposition(contentDisposition: string | null): string | null {
    if (!contentDisposition) {
      return null;
    }

    const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
    if (utf8Match?.[1]) {
      try {
        return decodeURIComponent(utf8Match[1]).replace(/(^\"|\"$)/g, '').trim();
      } catch (e) {
        return utf8Match[1].replace(/(^\"|\"$)/g, '').trim();
      }
    }

    const plainMatch = contentDisposition.match(/filename=([^;]+)/i);
    if (plainMatch?.[1]) {
      return plainMatch[1].replace(/(^\"|\"$)/g, '').trim();
    }

    return null;
  }

  private sanitizeFilename(name: string): string {
    const safe = (name || '').trim().replace(/[\\/:*?"<>|]/g, '_');
    return safe || 'reporte.pdf';
  }

  public existeTramite(anio: number, numero: number): Observable<boolean> {
    return this.http.get<boolean>(`${this.PORTAL_URL}tramite/${anio}/${numero}`).pipe(
      map((existe) => !!existe),
      catchError(() => of(false))
    );
  }
}
